export const getTasksColumnsNamedMapped = (columnName: string) => {
  const organizationsColumnsNamedMapped: Record<string, string> = {
    id: 'Id',
    name: 'Name',
    code: 'Code',
    businessAreaName: 'BusinessAreaName',
    status: 'Status',
    processesCount: 'UsersCount',
    period: 'Period',
    workload: 'Workload',
    estimatedCost: 'EstimatedCost',
    automated: 'Automated',
    users: 'UsersCount',
    organizationName: 'Organization',
    company: 'Company',
    workflow: 'Workflow',
  };

  return organizationsColumnsNamedMapped[columnName] ?? 'Name';
};
